import React, { useEffect, useRef, useState } from 'react';
import eventBus, { EVENT_NAMES } from '../../utils/event_bus';
import MapView, { MapViewRef } from '../components/map/map_view';
import { MapMarkerInfo } from '../components/map/map_view.logic';
import AllDriverListView from './all_driver_list_view';
import { Box, Paper, Typography, Dialog, DialogTitle, DialogContent, Grid, Divider } from '@mui/material';
import { LocationDriver } from '../../models/response/LocationDriver';
import { Driver } from '../../models/Driver';
import L from 'leaflet';

/**
 * 所有司机地图页面
 * 显示地图和悬浮在上面的所有司机列表
 */
const AllDriverListMap: React.FC = () => {
  // 创建地图组件的引用，用于调用地图组件的方法
  const mapRef = useRef<MapViewRef>(null);

  // 监听司机数据更新事件，将司机数据传递给地图组件
  useEffect(() => {
    const unsubscribe = eventBus.subscribe(EVENT_NAMES.DRIVER_DATA_UPDATED, (drivers) => {
      console.log('AllDriverListMap 收到司机数据更新事件:', drivers);
      if (mapRef.current && drivers && Array.isArray(drivers)) {
        // 将司机数据传递给地图组件，更新地图上的标记
        const validMarkers: MapMarkerInfo[] = drivers
          .map(driver => {
            // 获取司机的经纬度信息
            const lat = (driver as any).lat || (driver.lastPosition?.coordinates?.[1]);
            const lon = (driver as any).lon || (driver.lastPosition?.coordinates?.[0]);
            
            if (!lat || !lon) return null;
            
            // 获取车牌号信息
            let plateInfo = '';
            if (driver.trucks && driver.trucks.length > 0) {
              const truck = driver.trucks[0];
              plateInfo = `车牌: ${truck.plate || '未知'}<br>`;
            }
            
            return {
              latlng: new L.LatLng(lat, lon),
              title: driver.name || '未知司机',
              content: `${plateInfo}电话: ${driver.phone || '无'}<br>更新时间: ${driver.updatedAt ? new Date(driver.updatedAt).toLocaleString() : '未知'}`,
              type: 'driver',
              id: driver._id
            } as MapMarkerInfo;
          })
          .filter((marker): marker is MapMarkerInfo => marker !== null);
          
        mapRef.current.updateMapMarkers(validMarkers);
      }
    });
    
    return () => unsubscribe();
  }, []);

  return (
    <Box sx={{ position: 'relative', height: 'calc(100vh - 40px)', width: '100%' }}>
      {/* 全屏地图 */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
        <MapView 
          ref={mapRef}
          center={[39.9042, 116.4074]} // 默认北京中心点
          zoom={10}
          height="100%"
          width="100%"
        />
      </Box>
      
      {/* 悬浮在右侧的司机列表 */}
      <Paper 
        elevation={6}
        sx={{ 
          position: 'absolute',
          top: '20px',
          right: '20px',
          height: 'calc(100vh - 80px)',
          width: '35%',
          maxWidth: '100%',
          borderRadius: '8px',
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // 半透明黑色背景
          color: 'white', // 文字颜色设为白色
          overflow: 'auto', // 内容过多时可滚动
          zIndex: 1000 // 确保在地图上层
        }}
      >
        <AllDriverListSidebar />
      </Paper>
    </Box>
  );
};

// 司机列表侧边栏组件，适配半透明黑色背景
const AllDriverListSidebar: React.FC = () => {
  return (
    <Box sx={{ padding: '2px' }}>
      <Typography 
        sx={{ 
          color: 'white', 
          textAlign: 'center', 
          marginBottom: '10px',
          padding: '5px 0',
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
          fontWeight: 'bold'
        }}
      >
        所有司机列表
      </Typography>
      <AllDriverListView />
    </Box>
  );
};

export default AllDriverListMap;